import React from "react";

export interface CardDataDetailsProps {
    title: string;
    img: string;
    description: string;
    isCustom?: boolean;
    isArabic?: boolean;
    cardBodyColor?: string;
    titleColor?: string;
}

const CardDataDetails: React.FC<CardDataDetailsProps> = (props) => {
    const { description, img, title, isCustom, isArabic, cardBodyColor, titleColor } = props;
    return (
        <div
            style={{ border: "1px solid #EAECF0", fontFamily: "Inter", borderRadius: "12px", background: isArabic ? cardBodyColor : "initial" }}
            className="card-carousal-card overflow-hidden"
        >
            <img src={img} style={{ width: "100%", objectFit: "cover" }} alt="cardDataCarousal" />
            <div className="flex flex-col justify-center items-start space-y-4 px-4 py-2">
                <p
                    className={`text-lg font-bold text-black w-full ${isCustom ? "text-center" : isArabic ? "text-right" : "text-start"}`}
                    style={{ color: isArabic ? titleColor : undefined }}
                >
                    {title}
                </p>
                <p
                    className={`text-md text-black font-normal w-full ${isCustom ? "text-center px-2" : isArabic ? "text-right" : "text-start"}`}
                    style={{ color: isArabic ? titleColor : undefined }}
                >
                    {description}
                </p>
            </div>
        </div>
    );
};

export default CardDataDetails;
